<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div class="page-border">
      <div class="group1 content-card">
        <span class="word1" v-if="state.status == 0">等待审核</span>
        <span class="word1" v-else>审核结果</span>
      </div>
      <a-card :bordered="false" class="content-card">
        <div class="header" v-if="state.status == 0">
          <img
            class="pic1"
            referrerpolicy="no-referrer"
            src="/icon/reg/r2.png"
          />
          <div class="wrap1">
            <span class="word3">已完成资料的提交。</span>
            <span class="word4">请耐心等待后台审核。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 4">
          <img
            class="pic1"
            referrerpolicy="no-referrer"
            src="/icon/reg/cY.png"
          />
          <div class="wrap1">
            <span class="word3">初审通过</span>
            <span class="word4">已初审通过，请耐心等待下一步审核。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 1">
          <img
            class="pic1"
            referrerpolicy="no-referrer"
            src="/icon/reg/cY.png"
          />
          <div class="wrap1">
            <span class="word3">审核通过</span>
            <span class="word4">已审核通过，可前往教师小程序进行登录。</span>
          </div>
        </div>
        <div class="header" v-if="state.status == 5">
          <img
            class="pic1"
            referrerpolicy="no-referrer"
            src="/icon/reg/cY.png"
          />
          <div class="wrap1">
            <span class="word3">复审通过</span>
            <span class="word4">已复审通过，请耐心等待下一步审核。</span>
          </div>
        </div>
        <div class="box3"></div>
        <!-- 个人 -->
        <div class="four-one">
          <a-form :form="form" class="form-margin">
            <a-row :gutter="24">
              <!-- 基本资料 -->
              <div class="basics">
                <div class="section4">
                  <div class="mod4"></div>
                  <span class="txt1">基本资料</span>
                </div>
                <a-col :span="isMobile?24:11">
                  <div class="title">姓名</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'nickname',
                        {
                          rules: [
                            {
                              pattern: /^.{2,30}$/,
                              message: '请输入长度为2~10位的负责人姓名',
                            },
                          ],
                          initialValue: this.state.nickname,
                        },
                      ]"
                      placeholder="请输入您的真实姓名"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">性别</div>
                  <a-form-item>
                    <a-select
                      :disabled="true"
                      v-decorator="[
                        'gender',
                        {
                          rules: [{ message: '请选择' }],
                          initialvalue: this.state.gender,
                        },
                      ]"
                      placeholder="请选择您的性别"
                    >
                      <a-select-option value="1"> 男 </a-select-option>
                      <a-select-option value="2"> 女 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">主要联络手机号</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'mobile',
                        {
                          rules: [
                            {
                              pattern: /^1[3456789]\d{9}$/,
                              message: '请输入正确的手机号',
                            },
                          ],
                          initialValue: this.state.mobile,
                        },
                      ]"
                      placeholder="请输入您常用的手机号" :maxLength="11"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">身份证号</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'cardNo',
                        {
                          rules: [
                            {
                              required: true,
                              pattern:
                                /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                              message: '请输入正确的身份证号',
                            },
                          ],
                          initialValue: this.state.cardNo,
                        },
                      ]"
                      placeholder="请输入您的身份证号"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">银行卡号</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'bankCardNo',
                        {
                          rules: [
                            {
                              required: true,
                              pattern: /^\d{16,19}$/,
                              message: '请输入正确的银行卡号',
                            },
                          ],
                          initialValue: this.state.bankCardNo,
                        },
                      ]"
                      placeholder="请输入您常用的银行卡号"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">开户行</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'bankName',
                        {
                          rules: [
                            {
                              message: '请输入正确的开户行',
                            },
                          ],
                          initialValue: this.state.bankName,
                        },
                      ]"
                      placeholder="请输入开户行"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">执教年限</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'teachingYears',
                        {
                          rules: [
                            {
                              required: true,
                              message: '请输入正确的执教年限',
                            },
                          ],
                          initialValue: this.state.teachingYears,
                        },
                      ]"
                      placeholder="请输入执教年限"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:11">
                  <div class="title">授课方向</div>
                  <a-form-item>
                    <a-input
                      :disabled="true"
                      v-decorator="[
                        'applyCourseType',
                        {
                          rules: [
                            {
                              required: true,
                              message: '请输入授课方向',
                            },
                          ],
                          initialValue: this.state.applyCourseType,
                        },
                      ]"
                      placeholder="请输入授课方向"
                    />
                  </a-form-item>
                </a-col>

                <a-col :span="24">
                  <div class="title">个人简介</div>
                  <a-form-item>
                    <a-textarea
                      :disabled="true"
                      v-decorator="[
                        'intro',
                        {
                          rules: [{ validator: introRules }],
                          validateTrigger: 'blur',
                          initialValue: this.state.intro,
                        },
                      ]"
                      placeholder="请简单介绍自己，多行输入"
                      :auto-size="{
                        minRows: 5,
                        maxRows: 6,
                      }"
                      :maxLength="2000"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:8">
                  <a-form-item :required="true">
                    <div class="title">正面免冠照片（2寸）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_fullFaced"
                      class="fullFaced"
                      ref="protraitPhotoUrl"
                      :isSingle="false"
                      :maxlength="1"
                      :maxFileSize="204800"
                      :imageMatchHeight="626"
                      :imageMatchWidth="413"
                      messageTitle="正面免冠照片"
                      :sourceFileList="sourceFileList_fullFaced"
                    ></c-upload>
                    <!-- 限制照片为两寸  :twoInches="true"-->
                    <div class="remark">
                      符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                    </div>
                  </a-form-item>
                </a-col>

                <a-col :span="isMobile?24:8">
                  <!-- --------------------------------------------------------------------- -->
                  <a-form-item :required="true">
                    <div class="title">头像</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_headPortrait"
                      class="headPortrait"
                      :isSingle="false"
                      :maxlength="1"
                      :maxFileSize="1048576"
                      ref="avatarUrl"
                      :sourceFileList="sourceFileList_avatarUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:8">
                  <!-- --------------------------------------------------------------------- -->
                  <a-form-item :required="true">
                    <div class="title">8分钟说课视频（{{requiredSetting.length && requiredSetting[3].settingValue == '1'?'必':'选'}}填）</div>
                    <div v-if="reqDesc.talkingVideoUrl">
                      <video
                        style="height: 150px; width: 100%"
                        controls="controls"
                        muted="true"
                        :src="reqDesc.talkingVideoUrl"
                      ></video>
                    </div>
                    <c-upload
                      :disabled="true"
                      v-if="sourceFileListTalkingVideoUrl.length == 0"
                      accept="video/*"
                      ossType="institution"
                      ref="uploadVideo"
                      :maxlength="1"
                      :showUploadList="false"
                      messageTitle="说课视频"
                      :isSingle="false"
                      @uploadSuccess="uploadVideo"
                      :sourceFileList="sourceFileListTalkingVideoUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <div class="section18"></div>
                </a-col>
              </div>
              <!-- 学历信息 -->
              <div class="information">
                <a-col :span="24">
                  <div class="section4">
                    <div class="mod4"></div>
                    <span class="txt1">学历信息</span>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="education">学历及毕业院校
                    <span class="require">({{ requiredSetting.length && (requiredSetting[0].settingValue == '0' && requiredSetting[1].settingValue == '0')?'选':'必' }}填)</span>
                  </div>
                </a-col>
                <div
                  v-show="addCount != -1"
                  class="xueli"
                  v-for="(item, index) in state.degreeCertificatList"
                  :key="index"
                >
                  <a-col :span="18" v-if="index !== 0">
                    <div class="outer9"></div>
                  </a-col>
                  <a-col :span="isMobile?12:7">
                    <a-form-item>
                      <a-select
                        :disabled="true"
                        v-decorator="[
                          `degreeCertificatList[${index}].eduBackground`,
                          {
                            rules: [{ message: '请选择您的学历' }],
                            initialValue: item.eduBackground || undefined,
                          },
                        ]"
                        style="width: 150px"
                        placeholder="请选择您的学历"
                      >
                        <a-select-option
                          v-for="(item, index) in educationSelect"
                          :key="index"
                          :value="item"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="isMobile?12:13">
                    <a-form-item>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          `degreeCertificatList[${index}].text`,
                          {
                            rules: [{ message: '请输入您的毕业院校' }],
                            initialValue: item.text,
                          },
                        ]"
                        placeholder="请输入毕业院校"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="isMobile?12:7">
                    <a-form-item :required="true">
                      <div class="card">学历证({{requiredSetting.length && requiredSetting[0].settingValue == '1'?'必':'选'}}填)</div>
                      <c-upload
                        :disabled="true"
                        accept="image/*"
                        @uploadSuccess="uploadSuccess_diploma($event, index)"
                        class="diploma"
                        :isSingle="false"
                        :maxlength="1"
                        ref="diploma"
                        :sourceFileList="item.photoUrl2List"
                      ></c-upload>
                    </a-form-item>
                  </a-col>
                  <a-col :span="isMobile?12:13">
                    <a-form-item :required="true">
                      <div class="card">学位证({{requiredSetting.length && requiredSetting[1].settingValue == '1'?'必':'选'}}填)</div>
                      <c-upload
                        :disabled="true"
                        accept="image/*"
                        @uploadSuccess="uploadSuccess_photoUrl($event, index)"
                        class="diploma"
                        :isSingle="false"
                        :maxlength="1"
                        ref="photoUrl"
                        :sourceFileList="item.photoUrlList"
                      ></c-upload>
                    </a-form-item>
                  </a-col>
                </div>

                <a-col :span="24">
                  <div class="section18"></div>
                </a-col>
              </div>
              <!-- 其他资料 -->

              <div class="attachments">
                <a-col :span="24">
                  <div class="section4">
                    <div class="mod4"></div>
                    <span class="txt1">其他资料</span>
                  </div>
                </a-col>
                <a-col :span="isMobile?24:10">
                  <a-form-item :required="true" :class="[isMobile?'mb0':'']">
                    <div class="card">身份证（正面）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      :isSingle="false"
                      :maxlength="1"
                      class="frontIDCard"
                      @uploadSuccess="uploadSuccess_frontIDCard"
                      ref="cardFrontUrl"
                      :sourceFileList="sourceFileList_cardFrontUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:10">
                  <a-form-item :required="true" :class="[isMobile?'mb0':'']">
                    <div class="card">身份证（反面）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_backIDCard"
                      class="backIDCard"
                      :isSingle="false"
                      :maxlength="1"
                      ref="cardBackUrl"
                      :sourceFileList="sourceFileList_cardBackUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">健康证明（{{requiredSetting.length && requiredSetting[4].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_health"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.healthCertificateUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">老师资质证书（{{requiredSetting.length && requiredSetting[6].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_teacher"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.credentialInfoUrlList"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:9">
                  <a-form-item>
                    <div class="card">无犯罪记录证明（{{requiredSetting.length && requiredSetting[2].settingValue == '1'?'必':'选'}}填）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_criminal"
                      class="prove"
                      :isSingle="false"
                      :maxlength="1"
                      :sourceFileList="sourceFileList_noCriminalUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="isMobile?24:7">
                  <a-form-item>
                    <div class="card">无犯罪记录证明有效期（{{requiredSetting.length && requiredSetting[9].settingValue == '1'?'必':'选'}}填）</div>
                    <a-date-picker disabled
                      v-decorator="[
                        'noCriminalExpiryDate',
                        {
                          initialValue: this.state.noCriminalExpiryDate,
                        },
                      ]"/>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">从业经验（{{requiredSetting.length && requiredSetting[8].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_experience"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.experience"
                    ></c-upload>
                  </a-form-item>
                </a-col>
              </div>
            </a-row>
          </a-form>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import bureau from '../../api/bureau'
import user from '../../api/user'
import school from '../../api/school'
import teacher from '../../api/teacher'
import CUpload from '../../components/CUpload'
import moment from 'moment';
export default {
  components: {
    CUpload,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        gender: 1,
        intro: '',
        ...this.$store.state.register.form,
        degreeCertificatList: [],
        auditFailed: true,
      },
      reqDesc: {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        //credentialInfoUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      },
      educationSelect: ['专科', '本科', '研究生', '博士', '其他'],
      addCount: -1,
      sourceFileList: [],
      bureauId: '',
      loading: false,
      saveloading: false,
      status: '',
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_fullFaced: [],
      sourceFileList_avatarUrl: [],
      sourceFileList_noCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      requiredSetting:[],
      isMobile:false,
    }
  },
  created() {
    if(location.search.match(/webtoken=([\w\.\-_]+)(&|$)/) && location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1]){
      // console.log(location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1],'location')
      this.$ls.set('token', location.search.match(/webtoken=([\w\.\-_]+)(&|$)/)[1])
    }
    bureau.getBureauId().then((res) => {
      this.bureauId = res
    })
    let _this = this
    teacher.getMyself().then((res) => {
      console.log('res', res)
      _this.state = { ...this.state, ...res.data }
      _this.dataBack(res)
      // if (this.state.status == 3 || this.state.status == 2) {
      //   this.$message.warning('请重新登录账号')
      //   this.$router.push('/teacherInformation')
      // }
      this.getTeacherRequiredFieldsById(res.data.userId)
    })
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
    this.updateWindowWidth()
  },
  methods: {
    updateWindowWidth(){
      if(window.innerWidth<=800) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    introRules(rule, value, callback) {
      if (!value) {
        callback('请输入简介')
      } else if (value.trim().length === 0) {
        callback('请输入正确的简介')
      }
      callback()
    },
    getTeacherRequiredFieldsById(id){
      school.getTeacherRequiredFieldsById(id).then(res=>{
        this.requiredSetting = res.data.settingKeyValueDTOS
      })
    },
    //数据回显
    dataBack(res) {
      const data = {
        ...this.state,
      }
      if (data.degreeCertificatList && data.degreeCertificatList.length) {
        data.degreeCertificatList = data.degreeCertificatList
          .map((item) => {
            /**
             * 1 是学位
             */
            const photoUrlList = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 1
            ).map(i => i.fileUrl)

            const photoUrl = photoUrlList.length ? photoUrlList[0] : ''
            /**
             * 0 是学历
             */
            const photoUrl2List = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 0
            ).map(i => i.fileUrl)
            const photoUrl2 = photoUrl2List.length
              ? photoUrl2List[0]
              : ''
            return {
              eduBackground: item.description,
              text: item.text,
              photoUrl,
              photoUrlList,
              photoUrl2,
              photoUrl2List
            }
          })
          .filter((item) => {
            return item.photoUrl || item.photoUrl2 || item.text
          })
        console.log(' data.degreeCertificatList', data.degreeCertificatList)
        this.state.degreeCertificatList = data.degreeCertificatList
        this.addCount++
      }
      if (res.data.noCrimeExpiryDate && res.data.noCrimeExpiryDate[0].text !=='null') {
        this.state.noCriminalExpiryDate = moment(res.data.noCrimeExpiryDate[0].text)
      }
      if (data.gender == 2) {
        this.form.setFieldsValue({ gender: '女' })
      } else if (data.gender == 1) {
        this.form.setFieldsValue({ gender: '男' })
      }
      if (data.intro == 'undefined') {
        this.state.intro = ''
      } else {
        this.form.setFieldsValue({ intro: data.intro })
      }
      if (data.applyCourseType == 'undefined') {
        this.state.applyCourseType = ''
      } else {
        this.form.setFieldsValue({ applyCourseType: data.applyCourseType })
      }
      if (data.cardBackUrl) {
        this.sourceFileList_cardBackUrl.push(data.cardBackUrl) //身份证反面
      }
      if (data.cardFrontUrl) {
        this.sourceFileList_cardFrontUrl.push(data.cardFrontUrl) //身份证正面
      }
      if (res.data.protraitPhotoUrl) {
        this.sourceFileList_fullFaced.push(data.protraitPhotoUrl[0].fileUrl) //证件照
      }
      if (data.avatarUrl) {
        this.sourceFileList_avatarUrl.push(data.avatarUrl) //头像
      }
      if (data.talkingVideoUrl) {
        this.reqDesc.talkingVideoUrl = data.talkingVideoUrl[0].fileUrl
        this.sourceFileListTalkingVideoUrl.push(data.talkingVideoUrl[0].fileUrl) //8分钟说课视频
      }
      if (data.healthCertificateUrl && data.healthCertificateUrl.length !== 0) {
        this.reqDesc.healthCertificateUrl = data.healthCertificateUrl.map(
          (item) => {
            return item.fileUrl
          }
        ) //健康证明
      }
      if (data.credentialInfoUrl && data.credentialInfoUrl.length !== 0) {
        this.reqDesc.credentialInfoUrlList = data.credentialInfoUrl.map((item) => {
          return item.fileUrl
        }) //老师资质
      }
      if (data.noCriminalUrl && data.noCriminalUrl[0].fileUrl != 'undefined') {
        this.sourceFileList_noCriminalUrl.push(data.noCriminalUrl[0].fileUrl) //无犯罪记录
      }
      if (data.experience && data.experience.length !== 0) {
        this.reqDesc.experience = data.experience.map((item) => {
          return item.fileUrl
        }) //从业经验
      }
    },
    //正面免冠照片
    uploadSuccess_fullFaced(url) {
      if (!url.length) {
        this.reqDesc.protraitPhotoUrl = ''
        if(this.state.protraitPhotoUrl[0]){
          this.state.protraitPhotoUrl[0].fileUrl = ''
        } else{
          this.state.protraitPhotoUrl = []
        }
      }
      if (url.length > 0) {
        this.reqDesc.protraitPhotoUrl = url[0].url
      }
    },
    //头像
    uploadSuccess_headPortrait(url) {
      if (url.length > 0) {
        this.reqDesc.avatarUrl = url[0].url
      }
    },
    //学历证
    uploadSuccess_diploma(url, index) {
      console.log('url', url)
      console.log('index', index)
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl2 = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl2 = ''
      }
    },
    //学位证
    uploadSuccess_photoUrl(url, index) {
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl = ''
      }
    },
    //身份证正面
    uploadSuccess_frontIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardFrontUrl = url[0].url
      }
    },
    //身份证反面
    uploadSuccess_backIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardBackUrl = url[0].url
      }
    },
    //健康证明
    uploadSuccess_health(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.healthCertificateUrl = arr
    },
    //无犯罪记录证明
    uploadSuccess_criminal(url) {
      if (!url.length) {
        this.reqDesc.noCriminalUrl = ''
        this.state.noCriminalUrl[0].fileUrl = ''
      }
      if (url.length > 0) {
        this.reqDesc.noCriminalUrl = url[0].url
      }
    },
    //老师资质
    uploadSuccess_teacher(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.credentialInfoUrlList = arr
    },
    //从业经验
    uploadSuccess_experience(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.experience = arr
    },
    //8分钟说课视频
    uploadVideo(list) {
      this.reqDesc.talkingVideoUrl = list[list.length - 1].url
      this.sourceFileListTalkingVideoUrl.push(this.reqDesc.talkingVideoUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and  (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }  
}
div.page-border {
  background: #ececec;
}
.content-card {
  max-width: 1080px;
  min-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
#components-layout-demo-basic {
  text-align: left;
  height: 100vh;
  overflow: auto;
}
#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}
.ant-card {
  border-radius: 20px;
}
.group1 {
  height: 40px;
  padding-left: 30px;
}

.word1 {
  font-size: 24px;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
}
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}
.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;
  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }
  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}
.box3 {
  z-index: 19;
  width: calc(100% - 20px);
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 10px 40px 10px;
}
.section4 {
  z-index: auto;
  height: 22px;
  margin-bottom: 39px;
}

.mod4 {
  z-index: 79;
  width: 9px;
  height: 20px;
  border-radius: 4.5px 4.5px 4.5px 4.5px;
  background-color: rgba(78, 148, 255, 1);
  margin-top: 1px;
  display: inline-block;
}

.txt1 {
  z-index: 65;
  width: 80px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  text-align: left;
  vertical-align: top;
  margin-left: 12px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.education {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.education-rule {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7032;
  margin-bottom: 20px;
}
.section18 {
  z-index: 38;
  width: 100%;
  height: 4px;
  background-color: rgba(248, 248, 248, 1);
  align-self: center;
  margin: 10px 0;
}
.card {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.section27 {
  z-index: 35;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 40px;
}
.button {
  width: 140px;
  height: 42px;
  margin-left: 24px;
}
.footer {
  text-align: center;
  margin-top: 23px;
}
.remark {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #87888a;
  line-height: 20px;
}

/deep/ .fullFaced .ant-upload {
  width: 160px;
  height: 242px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .fullFaced .ant-spin-nested-loading {
  width: 160px;
}

//背景图
/deep/ .backgroundImage .ant-upload {
  width: 750px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 750px;
}
/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 750px;
  height: 250px;
  border: 0;
}
/deep/ .backgroundImage .ant-upload-list-item {
  width: 750px;
  height: 250px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .schoolPermit .ant-spin-nested-loading {
  width: 297px;
}
//头像
/deep/ .headPortrait .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .headPortrait .ant-spin-nested-loading {
  width: 160px;
}
//LOGO
/deep/ .LOGO .ant-upload {
  width: 250px;
  height: 250px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .LOGO .ant-spin-nested-loading {
  width: 250px;
}
/deep/ .LOGO .ant-upload-list-picture-card-container {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .LOGO .ant-upload-list-item {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .diploma .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .diploma .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .frontIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  background: url(/home/frontIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
  .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
    left: 33%;
  }
}

/deep/ .backIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  margin-left: 0px;
  background: url(/home/backIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
}
/deep/ .prove .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .prove .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .otherMaterialsUrls .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .proveHealth .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  /deep/ .ant-upload-list-item-list-type-picture-card {
    width: 160px;
    height: 160px;
    border: 0;
  }
  /deep/ .ant-upload-list-item {
    width: 160px;
    height: 160px;
    border: 0;
  }
  .ant-upload-text {
    display: none;
  }
}
/deep/ .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-item {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-picture-card-wrapper {
  width: 100%;
}

/deep/ .frontIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}
/deep/ .frontIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .frontIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .backIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

/deep/ .backIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .backIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .btn {
  width: 36px;
  height: 25px;
  font-size: 17px;
  margin-top: 10px;
  vertical-align: bottom;
}

.outer9 {
  z-index: 37;
  width: 130%;
  height: 1px;
  // background-color: #000;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}
.view-link {
  display: block;
  text-align: center;
}
.require{
  padding-left: 5px;
  color: red;
  font-size:14px;
  font-weight:400;
}
.form-margin {
  margin: 40px 0 0 39px
}
.mb0 {
  margin-bottom: -40px !important;
}
@media screen and (max-width: 800px) {
  .content-card {
    min-width: calc(100vw - 20px);
    margin-left: auto;
    margin-right: auto;
  }
  /deep/ .ant-card-body {
    padding: 12px !important;
  }
  /deep/ .ant-col {
    padding: 0 !important;
  }
  .form-margin {
    margin: 40px 0 0 9px
  }
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
